"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var time_1 = require("../../../common/helpers/time");
var book_drive_controller_1 = __importDefault(require("./book-drive.controller"));
var book_drive_html_1 = __importDefault(require("./book-drive.html"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.student.drives.create", {
        url: "/create/:id",
        template: book_drive_html_1.default,
        controller: book_drive_controller_1.default,
        controllerAs: "vm",
        resolve: {
            drive: getDrive,
            locations: getLocations,
        },
        data: {
            authorizedRoles: [USER_ROLES.admin, USER_ROLES.owner, USER_ROLES.student],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
function getLocations($stateParams, UsersModel) {
    return UsersModel.getStudentPickupLocationsByDriveSession($stateParams.id).then(function (response) {
        response.pickuplocations.map(function (location) {
            location.name = location.name + " " + location.address.street;
            return location;
        });
        response.dropofflocations.map(function (location) {
            location.name = location.name + " " + location.address.street;
            return location;
        });
        return response;
    });
}
getLocations.$inject = ["$stateParams", "UsersModel"];
function getDrive($stateParams, DrivesModel) {
    return DrivesModel.getDriveByID($stateParams.id).then(function (response) {
        var startTimeDate = typeof response.drive.start_time === "string"
            ? (0, time_1.timeStringToDate)(response.drive.start_time)
            : response.drive.start_time;
        // The school's observation slots arrive on response.drive.slots; the student
        // picks one of those rather than defining their own window.
        response.drive.start_time = startTimeDate.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });
        var endTime = (0, time_1.addMinutes)(startTimeDate, response.drive.session_length);
        response.drive.end_time = endTime.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });
        // @todo this is a hack for a bug fix
        if (!response.drive.type.allow_custom_dropoff_locations === false &&
            !response.drive.dropofflocation) {
            response.drive.dropofflocation = response.drive.location;
        }
        if (!response.drive.type.allow_custom_pickup_locations === false &&
            !response.drive.pickuplocation) {
            response.drive.dropofflocation = response.drive.location;
        }
        return response.drive;
    });
}
getDrive.$inject = ["$stateParams", "DrivesModel"];
exports.default = angular_1.default
    .module("student.drives.create", [])
    .controller("StudentBookDriveController", book_drive_controller_1.default)
    .config(config);
